import React from "react";
import { ShieldCheck, Medal, GraduationCap } from "@phosphor-icons/react";
import { DASHBOARD } from "@/constants/testIds";

const VET_IMG =
    "https://images.unsplash.com/photo-1655841769348-fb2f0ead0216?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHx2ZXRlcmFuJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzg0ODU1OTc1fDA&ixlib=rb-4.1.0&q=85";

export const VeteranInitiative = () => {
    return (
        <section
            data-testid={DASHBOARD.veteran}
            className="relative overflow-hidden rounded-lg border border-[#f59e0b]/25 bg-[#080604]"
        >
            <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_1fr]">
                <div className="relative h-[280px] lg:h-full">
                    <img
                        src={VET_IMG}
                        alt="Veteran in clean energy training"
                        className="absolute inset-0 h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/40 to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-black/40 lg:to-black/85" />
                    <div className="absolute left-6 top-6 flex items-center gap-2 rounded-full bg-[#f59e0b]/15 px-3 py-1 backdrop-blur-sm">
                        <ShieldCheck size={14} color="#f59e0b" weight="fill" />
                        <span className="font-mono-metric text-[10px] uppercase tracking-[0.24em] text-[#f59e0b]">
                            Signature Program
                        </span>
                    </div>
                </div>

                <div className="p-6 sm:p-8 lg:p-12">
                    <h2 className="font-editorial text-2xl leading-tight text-white sm:text-3xl md:text-4xl">
                        EVIQ Green Veterans <span className="italic text-[#f59e0b]">Foundation.</span>
                    </h2>
                    <p className="mt-4 text-sm text-zinc-400 lg:text-base">
                        A defining part of the EVIQ brand. Every subscription helps veterans train
                        for careers in EV maintenance, battery technology, and clean-energy
                        infrastructure.
                    </p>

                    <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-3">
                        {[
                            { icon: GraduationCap, label: "Scholarships", value: "84" },
                            { icon: Medal, label: "Certifications funded", value: "212" },
                            { icon: ShieldCheck, label: "Veteran hires supported", value: "37" },
                        ].map((s) => (
                            <div
                                key={s.label}
                                className="rounded-md border border-[#1f1f22] bg-[#050505] p-4"
                            >
                                <s.icon size={16} color="#f59e0b" weight="fill" />
                                <div className="mt-3 font-mono-metric text-2xl font-bold text-white">
                                    {s.value}
                                </div>
                                <div className="mt-1 text-xs text-zinc-500">{s.label}</div>
                            </div>
                        ))}
                    </div>

                    <p className="mt-8 border-l-2 border-[#f59e0b]/60 pl-4 font-editorial text-lg italic leading-snug text-zinc-300">
                        "27 Veterans received EV training this month. 183 trees planted. 8,400 lbs of
                        plastic removed. That's a narrative people remember."
                    </p>
                </div>
            </div>
        </section>
    );
};

export default VeteranInitiative;
